import { Link } from "react-router-dom";
import { Vault } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#413830] border-t border-[rgba(212,175,55,0.25)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-5">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 border border-gold/60 flex items-center justify-center">
              <Vault className="w-4 h-4 text-gold" />
            </span>
            <span className="font-serif text-lg tracking-[0.18em] text-[#f3e5ab]">
              EMISON <span className="gold-text">MANAGEMENT</span>
            </span>
          </div>
          <p className="text-sm text-[#b09a7a] leading-relaxed max-w-sm">
            Your Funding Partner. Where our dream is helping you achieve your
            financial success — capital for artists and record labels, without
            giving up ownership.
          </p>
        </div>

        <div className="md:col-span-2 space-y-4">
          <p className="text-xs font-serif uppercase tracking-[0.2em] text-gold">Explore</p>
          <div className="flex flex-col gap-3 text-sm text-[#d8cdb8]">
            <Link to="/" data-testid="footer-link-home" className="hover:text-gold transition-colors">Home</Link>
            <Link to="/about" data-testid="footer-link-about" className="hover:text-gold transition-colors">About</Link>
            <Link to="/faq" data-testid="footer-link-faq" className="hover:text-gold transition-colors">FAQ</Link>
            <Link to="/apply" data-testid="footer-link-apply" className="hover:text-gold transition-colors">Apply</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="hover:text-gold transition-colors">Contact</Link>
            <Link to="/book" data-testid="footer-link-book" className="hover:text-gold transition-colors">Book A Call</Link>
          </div>
        </div>

        <div className="md:col-span-3 space-y-4">
          <p className="text-xs font-serif uppercase tracking-[0.2em] text-gold">Funding</p>
          <div className="flex flex-col gap-3 text-sm text-[#d8cdb8]">
            <Link to="/products/artist-capital-loans" data-testid="footer-link-artist-capital-loans" className="hover:text-gold transition-colors">Artist Capital Loans</Link>
            <Link to="/products/label-lines-of-credit" data-testid="footer-link-label-lines-of-credit" className="hover:text-gold transition-colors">Label Lines of Credit</Link>
            <Link to="/products/business-credit-cards" data-testid="footer-link-business-credit-cards" className="hover:text-gold transition-colors">Business Credit Cards</Link>
            <Link to="/products/catalog-advances" data-testid="footer-link-catalog-advances" className="hover:text-gold transition-colors">Catalog Advances</Link>
          </div>
        </div>

        <div className="md:col-span-2 space-y-4">
          <p className="text-xs font-serif uppercase tracking-[0.2em] text-gold">Contact</p>
          <div className="flex flex-col gap-3 text-sm text-[#d8cdb8]">
            <span>11111 Katy Freeway, Suite 910<br />Houston, TX 77079</span>
            <a href="tel:8887080195" data-testid="footer-link-phone" className="hover:text-gold transition-colors">888-708-0195</a>
            <a
              href="mailto:info@emisonmanagement.com"
              data-testid="footer-contact-email"
              className="hover:text-gold transition-colors break-all"
            >
              info@emisonmanagement.com
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[rgba(212,175,55,0.15)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
          <p className="text-xs text-[#b09a7a]">
            Copyright © 2026 Emison Management. All Rights Reserved.
          </p>
          <Link
            to="/dashboard"
            data-testid="footer-link-vault-file"
            className="text-xs font-serif uppercase tracking-[0.2em] text-[#8a7358] hover:text-gold transition-colors order-first sm:order-none"
          >
            View your vault file
          </Link>
          <p className="text-xs text-[#8a7358] max-w-xl">
            Emison Management is a funding consultancy, not a lender. All
            financing is subject to approval and provided through partner
            institutions.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
